export default function PageHero({ image, eyebrow, title, subtitle }) {
  return (
    <section className="relative pt-32 pb-20 lg:pt-44 lg:pb-28 overflow-hidden" data-testid="page-hero">
      <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-b from-[rgba(8,24,42,0.85)] via-[rgba(8,24,42,0.7)] to-[rgba(8,24,42,0.9)]" />
      <div className="absolute inset-0 bg-gradient-to-r from-[rgba(8,24,42,0.55)] via-transparent to-transparent" />
      <div className="relative max-w-7xl mx-auto px-5 lg:px-10">
        <div className="max-w-3xl">
          {eyebrow && (
            <div className="fade-up inline-flex items-center px-3 py-1.5 rounded-full bg-white/15 backdrop-blur border border-white/25 text-white text-[11px] uppercase tracking-[0.22em]">
              {eyebrow}
            </div>
          )}
          <h1 className="fade-up fade-up-2 font-display text-white mt-5 text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight" style={{ textShadow: "0 2px 24px rgba(8,24,42,0.7)" }}>
            {title}
          </h1>
          {subtitle && (
            <p className="fade-up fade-up-3 mt-5 text-white text-base sm:text-lg max-w-2xl leading-relaxed" style={{ textShadow: "0 1px 12px rgba(8,24,42,0.8)" }}>
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
